import { useState, useEffect, useContext, useRef } from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'Redux/Actions/actions';
import classes from './index.module.css';

import { ReactComponent as Overview } from 'Components/UI_Library/Icons/MobileIcons/Overview.svg';
import { ReactComponent as Dashboard } from 'Components/UI_Library/Icons/MobileIcons/Dashboard.svg';
import { ReactComponent as Bills } from 'Components/UI_Library/Icons/MobileIcons/Bills.svg';
import { ReactComponent as Approvals } from 'Components/UI_Library/Icons/MobileIcons/Approvals.svg';
import { ReactComponent as Payments } from 'Components/UI_Library/Icons/MobileIcons/Payments.svg';
import { ReactComponent as Expenses } from 'Components/UI_Library/Icons/MobileIcons/Expenses.svg';
import { ReactComponent as Cards } from 'Components/UI_Library/Icons/MobileIcons/Card.svg';
import { ReactComponent as Budgets } from 'Components/UI_Library/Icons/MobileIcons/Budgets.svg';
import { ReactComponent as Payroll } from 'Components/UI_Library/Icons/MobileIcons/Payroll.svg';
import { ReactComponent as Accounts } from 'Components/UI_Library/Icons/MobileIcons/Accounts.svg';
import { ReactComponent as Setup } from 'Components/UI_Library/Icons/MobileIcons/Settings.svg';
import { ReactComponent as Help } from 'Components/UI_Library/Icons/MobileIcons/Help.svg';
import { ReactComponent as Team } from 'Components/UI_Library/Icons/MobileIcons/Team.svg';
import { ReactComponent as Gift } from 'Components/UI_Library/Icons/MobileIcons/Gift.svg';
import { ReactComponent as Recipients } from 'Components/UI_Library/Icons/MobileIcons/Recipients.svg';
import { ReactComponent as Lock } from 'Components/UI_Library/Icons/NewIconSet/MenuLockIcon.svg';
import { ReactComponent as FenixLogo } from 'Components/UI_Library/Icons/FenixLogo.svg';

import { getCompanyStatus, getCurrentCompanyId, getCurrentUserId } from 'Lib/Utils';
import { isOktaInternalAuthToken } from 'Lib/Utils/authToken';
import AccountToggle from './AccountToggle/AccountToggle';
import Prism from 'Components/UI_Library/Prism/Prism';
import { NotificationAction } from 'Components/UI_Library/Notification';
import { NotificationsContext } from 'Components/Notifications';
import { cardsHomeUrl } from 'Components/CardsGPS/utils/constants';
import { getAttachedCompanies } from 'Backend/users/utils/attachedCompanies/getAttachedCompanies';
import Badge from 'Components/UI_Library/Badge/Badge';
import { planMap } from 'Components/Setup/Billing/utils/Utils';
import LiveAgent from 'Components/LiveChat';
import { GeneralModal } from 'Components/UI_Library/Modals';
import ReactDOM from 'react-dom';
import { useOnClickOutside } from 'Components/UI_Library/ReusableHooks/useDetectOutsideClick';
import { useOnClickOutsideSingle } from 'Components/UI_Library/ReusableHooks/useDetectOutsideClickSingle';
import OnBehalfOfUserToggle from './OnBehalfOfUserToggle/OnBehalfOfUserToggle';
import Home from '../Fenix/Home';
import { useGetCompany } from 'Backend/company/getCompany';

const DesktopMenu = (props) => {
    const menuInitialState =
        localStorage.getItem('isMenuExpand') === 'true' || localStorage.getItem('isMenuExpand') === null;
    const notifications = useContext(NotificationsContext);
    const [isExpanded, setIsExpanded] = useState(menuInitialState);
    const [currentPage, setCurrentPage] = useState(null);
    const [numAccounts, setNumAccounts] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showLiveChat, setShowLiveChat] = useState(false);
    const matchSetup = useMatch('/setup/*');
    const matchApprovals = useMatch('/approvals/*');
    const matchPayments = useMatch('/payments/*');
    const matchCardsGPS = useMatch(`${cardsHomeUrl}/*`);
    const matchAccounts = useMatch('/accounts/*');
    const matchExpenses = useMatch('/expenses/*');
    const matchBudgets = useMatch('/budgets/*');
    const matchOverview = useMatch('/overview/*');
    const matchBills = useMatch('/bills/*');
    const isFenix = isOktaInternalAuthToken();
    const isBusinessAccountPlan = notifications?.subscription?.planId === planMap('Business Account');
    const isPremiumPlan = notifications?.subscription?.planId === planMap('Enterprise');
    const liveChat = useRef(null);
    const liveChatToggle = useRef(null);

    useOnClickOutside(liveChat, liveChatToggle, () => setShowLiveChat(false));
    const { data: company } = useGetCompany();

    const toggleWidth = () => {
        localStorage.setItem('isMenuExpand', !isExpanded);
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        if (props.page?.menuName !== currentPage) setCurrentPage(props.page.menuName);
    }, [props.page]);

    useEffect(() => {
        const Permission = getAttachedCompanies();
        setNumAccounts(Permission.filter((permission) => permission.companyId !== getCurrentCompanyId()).length);
    }, [company]);

    const approvalActiveClassName =
        location?.pathname === '/approvals/pending' ||
        location?.pathname === '/approvals/approved' ||
        location?.pathname === '/approvals/declined'
            ? classes.active
            : location?.pathname?.startsWith('/approvals')
            ? classes.childActive
            : undefined;

    const isActive = (className, pathNames, match) => {
        if (!pathNames) return '';

        let matchedPath = false;
        pathNames.forEach((path) => {
            if (location?.pathname?.startsWith(path)) matchedPath = true;
        });

        if (matchedPath) return className;
        if (!match) return '';
        return '';
    };

    const baseCurrency = company?.baseCurrency || 'AUD';
    const buyCurrency = baseCurrency !== 'AUD' ? 'AUD' : 'USD';

    const parentSectionClass = (section, secondSection) => {
        if (location?.pathname === section) return classes.active;
        else if (location?.pathname?.startsWith(section) || location?.pathname?.startsWith(secondSection))
            return classes.childActive;
        return undefined;
    };

    const paymentsClass = () => {
        if (isBusinessAccountPlan && location.pathname.startsWith('/payments/payroll')) return '';

        const childActive = () =>
            location.pathname.startsWith('/payments/batch') ||
            location.pathname.startsWith('/payments/payroll') ||
            location.pathname.startsWith('/payments/partial');

        if (!location?.pathname || typeof location.pathname !== 'string') return '';
        if (childActive()) return classes.childActive;
        if (matchPayments) return classes.active;
        return '';
    };

    const dashboardClass = () => {
        if (!location?.pathname || typeof location.pathname !== 'string') return '';
        if (location.pathname === '/') return classes.active;
        if (location.pathname.startsWith('/dashboard')) return classes.active;
        return '';
    };

    const renderInvalidSubscriptionLinks = () => {
        return (
            <>
                <div className={`${classes.section} ${classes.first}`}>
                    <div className={classes.accountCard}>
                        <AccountToggle expanded={isExpanded} style={mapPlanName()} />
                    </div>
                    {isFenix ? (
                        <Prism featureName="OnBehalfOfUser" fallback={<></>}>
                            <div className={`${classes.accountCard} ${classes.flexWrap}`}>
                                <OnBehalfOfUserToggle expanded={isExpanded} style={mapPlanName()} />
                            </div>
                        </Prism>
                    ) : null}
                </div>
                <div className={`${classes.section} ${classes.second}`}>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(
                            parentSectionClass('/setup'),
                            ['/setup/account'],
                            matchSetup
                        )}`}
                        title={isExpanded ? '' : 'Setup'}
                        to="/setup/account"
                    >
                        <div className={classes.iconWrapper}>
                            <Setup />
                        </div>
                        <span className={classes.pageLinkText}>Setup</span>
                        <div className={classes.childrenIndicator}>
                            <div />
                            <div />
                        </div>
                    </NavLink>

                    {matchSetup !== null && (
                        <div className={classes.childPageSection}>
                            <NavLink
                                className={`${classes.pageLink} ${classes.active}`}
                                title={isExpanded ? '' : 'Billing details'}
                                to="/setup/billing"
                            >
                                <span className={classes.pageLinkText}>Billing</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </>
        );
    };

    const status = getCompanyStatus();

    const wrapperStyles = () => {
        let styles = `${classes.wrapper}`;
        if (isExpanded) styles += ` ${classes.expanded}`;
        if (isBusinessAccountPlan) styles += ` ${classes.businessAccount}`;
        if (isPremiumPlan) styles += ` ${classes.premium}`;
        else styles += ` ${classes.desktop}`;
        return styles;
    };

    const logo = () => {
        return (
            <div className={classes.topSection}>
                {isFenix ? (
                    <div className={classes.fenixLogo}>
                        <FenixLogo />
                    </div>
                ) : (
                    <>
                        <NavLink to="/dashboard" className={classes.logo}>
                            <svg viewBox="0 0 90 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    className={classes.icon}
                                    d="M5.68769 0C8.5133 0 10.6826 0.501319 12.1957 1.50396C13.7088 2.48836 14.4653 4.11081 14.4653 6.3713C14.4653 8.65003 13.6997 10.2998 12.1684 11.3207C10.6371 12.3233 8.4495 12.8246 5.60566 12.8246H4.51577C4.3777 12.8246 4.26577 12.9366 4.26577 13.0746V18.9186C4.26577 19.0567 4.15384 19.1686 4.01577 19.1686H0.25C0.111929 19.1686 0 19.0567 0 18.9186V7.4044C0 7.25759 0.125902 7.14238 0.272132 7.15538L4.40719 7.52289C4.53618 7.53436 4.63506 7.64241 4.63506 7.7719L4.63511 9.35113C4.63511 9.50382 4.68973 9.65147 4.7891 9.7674C5.019 10.0356 5.42281 10.0667 5.69103 9.83678L10.4649 6.75002C10.8043 6.45916 10.7332 6.00862 10.4649 5.77872L5.69103 2.69194C5.5751 2.59257 5.42744 2.53796 5.27475 2.53796C4.92149 2.53796 4.63511 2.82433 4.63511 3.1776L4.63506 4.75967C4.63506 4.88754 4.53856 4.9948 4.41139 5.00827L0.276333 5.44627C0.128669 5.46191 0 5.34615 0 5.19766V0.697945C0 0.57842 0.0845497 0.475464 0.202059 0.453606C1.07203 0.29178 1.98909 0.177038 2.95322 0.109379C3.99232 0.0364596 4.90381 0 5.68769 0Z"
                                />
                                <g className={classes.wordmark}>
                                    <path d="M46.6111 0.84039C46.6111 0.686456 46.4733 0.569092 46.3214 0.593572L42.747 1.16931C42.6259 1.18882 42.5368 1.2934 42.5368 1.41613V13.2895C42.5368 14.2192 42.6188 15.0669 42.7829 15.8326C42.9652 16.5982 43.2751 17.2545 43.7126 17.8014C44.1501 18.33 44.7335 18.7493 45.4626 19.0592C46.1918 19.3509 47.1124 19.4967 48.2245 19.4967C49.0995 19.4967 49.8378 19.4238 50.4394 19.278C50.8558 19.177 51.2083 19.0102 51.3858 18.9171C51.4633 18.8764 51.509 18.7953 51.5089 18.7077L51.5062 15.9488C51.506 15.7738 51.3304 15.6526 51.1637 15.7057C50.8724 15.7983 50.5581 15.877 50.2206 15.9419C49.7649 16.0149 49.3182 16.0513 48.8807 16.0513C47.9692 16.0513 47.3585 15.7961 47.0486 15.2857C46.757 14.7752 46.6111 14.0916 46.6111 13.2348V8.42606C46.6111 8.28799 46.7231 8.17606 46.8611 8.17606H51.2558C51.3939 8.17606 51.5058 8.06413 51.5058 7.92606V5.03532C51.5058 4.89725 51.3939 4.78532 51.2558 4.78532H46.8611C46.7231 4.78532 46.6111 4.67339 46.6111 4.53532V0.84039Z" />
                                    <path d="M20.0393 4.4025C21.2424 4.4025 22.2451 4.53922 23.0472 4.81267C23.8493 5.08611 24.4873 5.47805 24.9613 5.98849C25.4535 6.49892 25.7999 7.11873 26.0004 7.84792C26.2009 8.57711 26.3012 9.38834 26.3012 10.2816V14.1169C26.3012 14.2654 26.1725 14.3811 26.0249 14.3655L21.6661 13.9038C21.539 13.8903 21.4425 13.7831 21.4425 13.6552L21.4424 12.5269C21.4424 12.2624 21.228 12.0479 20.9634 12.0479C20.8491 12.0479 20.7385 12.0888 20.6517 12.1632L17.0767 14.4748C16.8759 14.647 16.8226 14.9843 17.0767 15.2022L20.6517 17.5137C20.8525 17.6859 21.1549 17.6626 21.3271 17.4618C21.4015 17.3749 21.4424 17.2644 21.4424 17.15L21.4425 16.0249C21.4425 15.8954 21.5413 15.7873 21.6703 15.7758L26.0291 15.3885C26.1753 15.3755 26.3012 15.4907 26.3012 15.6375V18.5572C26.3012 18.6747 26.2196 18.7764 26.1046 18.8004C25.5403 18.9177 24.7946 19.0496 23.8675 19.196C22.8284 19.3783 21.5706 19.4694 20.094 19.4694C19.1642 19.4694 18.3166 19.3874 17.5509 19.2233C16.8035 19.0592 16.1563 18.7949 15.6094 18.4303C15.0625 18.0475 14.6433 17.5553 14.3516 16.9537C14.0599 16.3521 13.9141 15.6138 13.9141 14.7388C13.9141 13.9002 14.0781 13.1892 14.4063 12.6059C14.7526 12.0225 15.2084 11.5577 15.7735 11.2113C16.3386 10.865 16.9858 10.6188 17.715 10.473C18.4442 10.3089 19.2007 10.2269 19.9846 10.2269C20.5132 10.2269 20.9781 10.2543 21.3792 10.3089C21.6407 10.3317 21.8704 10.3615 22.0681 10.3985C22.2314 10.429 22.3909 10.3077 22.3909 10.1416V10.0902C22.3909 9.39745 22.1813 8.84144 21.762 8.42216C21.3427 8.00288 20.6135 7.79323 19.5744 7.79323C18.8817 7.79323 18.1981 7.84792 17.5236 7.9573C17.0501 8.02129 16.7967 8.13469 16.5174 8.25965C16.4987 8.26802 16.4798 8.27646 16.4608 8.28492C16.3018 8.35573 16.129 8.23709 16.129 8.06297V5.06895C16.129 4.9513 16.2108 4.84965 16.326 4.82582C16.5792 4.77344 17.0199 4.68576 17.3048 4.6486C17.7241 4.57568 18.1616 4.52099 18.6173 4.48453C19.0913 4.42984 19.5653 4.4025 20.0393 4.4025Z" />
                                    <path d="M40.7942 4.78532C40.9613 4.78532 41.0814 4.94616 41.0336 5.10626C40.2423 7.75706 39.4173 10.2478 38.5586 12.5785C37.6653 15.0031 36.69 17.3547 35.6327 19.6335C35.2499 20.4538 34.8671 21.1465 34.4842 21.7117C34.1014 22.295 33.6821 22.769 33.2264 23.1336C32.7706 23.5164 32.2511 23.7899 31.6677 23.9539C31.1026 24.1362 30.4372 24.2274 29.6716 24.2274C29.0335 24.2274 28.4411 24.1636 27.8942 24.036C27.4595 23.946 27.0865 23.8438 26.775 23.7292C26.662 23.6876 26.6003 23.5677 26.626 23.45L27.2324 20.6745C27.2644 20.528 27.4171 20.4428 27.5601 20.4879C27.8725 20.5865 28.1571 20.6571 28.4137 20.6999C28.7419 20.7546 29.0882 20.7819 29.4528 20.7819C30.182 20.7819 30.738 20.5814 31.1208 20.1804C31.5015 19.817 31.8246 19.3141 32.0903 18.6717C32.1177 18.6054 32.114 18.5306 32.0815 18.4666C31.1688 16.6692 30.2561 14.6609 29.3434 12.4418C28.4489 10.2494 27.605 7.80374 26.8117 5.10498C26.7648 4.94521 26.8847 4.78532 27.0512 4.78532H30.8448C30.959 4.78532 31.0586 4.86263 31.0872 4.97314C31.2579 5.63215 31.4515 6.34431 31.6677 7.10962C31.9229 7.92996 32.1873 8.76853 32.4607 9.62533C32.7342 10.4639 33.0076 11.2842 33.2811 12.0863C33.4836 12.6432 33.6773 13.165 33.8622 13.6516C33.9443 13.8675 34.248 13.8636 34.3235 13.6452C34.4912 13.1605 34.6633 12.6408 34.8397 12.0863C35.0949 11.2842 35.341 10.4639 35.578 9.62533C35.8332 8.76853 36.0702 7.92996 36.289 7.10962C36.5053 6.34431 36.6988 5.63215 36.8695 4.97314C36.8981 4.86263 36.9977 4.78532 37.1119 4.78532H40.7942Z" />
                                    <path d="M61.6618 8.2125C61.6101 8.31877 61.4911 8.37413 61.376 8.34703C61.0568 8.27181 60.694 8.19659 60.2878 8.12137C59.7956 8.01199 59.267 7.9573 58.7019 7.9573C58.4466 7.9573 58.1367 7.98465 57.7721 8.03934C57.5267 8.06517 57.3225 8.09558 57.1594 8.13057C57.0515 8.15374 56.9791 8.25166 56.9791 8.36207V18.9186C56.9791 19.0567 56.8672 19.1686 56.7291 19.1686H53.1548C53.0167 19.1686 52.9048 19.0567 52.9048 18.9186V5.01979C52.9048 4.88793 53.0051 4.7789 53.1367 4.77062C54.096 4.71025 57.7532 4.48453 58.8112 4.48453C59.03 4.48453 59.2943 4.50276 59.6042 4.53922C59.9141 4.55745 60.224 4.59391 60.5339 4.6486C60.8438 4.68506 61.1538 4.73975 61.4637 4.81267C61.7374 4.86097 62.2447 5.04537 62.8001 5.30812C62.924 5.36672 62.9743 5.51553 62.9143 5.63874L61.6618 8.2125Z" />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M75.8559 15.0669C76.184 14.119 76.3481 13.0799 76.3481 11.9496C76.3481 10.8194 76.1749 9.78939 75.8285 8.85968C75.4821 7.92996 74.9991 7.13696 74.3792 6.48069C73.7594 5.82442 73.012 5.31398 72.137 4.94939C71.2802 4.58479 70.3322 4.4025 69.2931 4.4025C68.2723 4.4025 67.3243 4.58479 66.4493 4.94939C65.5925 5.31398 64.8451 5.82442 64.207 6.48069C63.5872 7.13696 63.095 7.92996 62.7304 8.85968C62.3841 9.78939 62.2109 10.8194 62.2109 11.9496C62.2109 13.0799 62.3841 14.119 62.7304 15.0669C63.0768 15.9966 63.5599 16.7987 64.1797 17.4732C64.7995 18.1295 65.5378 18.6399 66.3946 19.0045C67.2696 19.3691 68.2358 19.5514 69.2931 19.5514C70.3687 19.5514 71.3349 19.3691 72.1917 19.0045C73.0667 18.6399 73.8141 18.1295 74.4339 17.4732C75.0537 16.7987 75.5277 15.9966 75.8559 15.0669ZM71.426 8.9964C71.9365 9.70736 72.1917 10.6918 72.1917 11.9496C72.1917 13.2075 71.9365 14.2101 71.426 14.9575C70.9338 15.6867 70.2229 16.0513 69.2931 16.0513C68.3634 16.0513 67.6433 15.6867 67.1329 14.9575C66.6225 14.2101 66.3673 13.2075 66.3673 11.9496C66.3673 10.6918 66.6225 9.70736 67.1329 8.9964C67.6433 8.26721 68.3634 7.90261 69.2931 7.90261C70.2229 7.90261 70.9338 8.26721 71.426 8.9964Z"
                                    />
                                    <path d="M77.5853 5.46542C77.5853 5.35412 77.6587 5.25601 77.7661 5.22684C78.4312 5.04617 79.2642 4.88077 80.2651 4.73063C81.3589 4.54833 82.5074 4.45718 83.7105 4.45718C84.9319 4.45718 85.9437 4.62125 86.7458 4.94939C87.5661 5.25929 88.2133 5.70592 88.6872 6.28928C89.1612 6.87263 89.4985 7.56536 89.699 8.36747C89.8995 9.16958 89.9998 10.0628 89.9998 11.0472V18.9186C89.9998 19.0567 89.8879 19.1686 89.7498 19.1686H86.1754C86.0374 19.1686 85.9254 19.0567 85.9254 18.9186V11.5395C85.9254 10.2269 85.7523 9.29719 85.4059 8.7503C85.0595 8.2034 84.4124 7.92996 83.4644 7.92996C83.1727 7.92996 82.8628 7.94819 82.5347 7.98465C82.2953 7.99795 82.0753 8.0161 81.8747 8.0391C81.7511 8.05328 81.6597 8.15909 81.6597 8.2835V18.9186C81.6597 19.0567 81.5477 19.1686 81.4097 19.1686H77.8353C77.6972 19.1686 77.5853 19.0567 77.5853 18.9186V5.46542Z" />
                                </g>
                            </svg>
                        </NavLink>
                        <div className={classes.toggle} onClick={() => toggleWidth()}>
                            <div />
                            <div />
                        </div>
                    </>
                )}
            </div>
        );
    };

    const mapPlanName = () => {
        if (isBusinessAccountPlan) return 'businessAccount';
        if (isPremiumPlan) return 'premium';
        return 'standard';
    };

    const accountSelection = () => (
        <div className={`${classes.section} ${classes.first}`}>
            <div className={classes.accountCard}>
                <AccountToggle expanded={isExpanded} style={mapPlanName()} />
            </div>
            {isFenix ? (
                <Prism featureName="OnBehalfOfUser" fallback={<></>}>
                    <div className={`${classes.accountCard} ${classes.flexWrap}`}>
                        <OnBehalfOfUserToggle expanded={isExpanded} style={mapPlanName()} />
                    </div>
                </Prism>
            ) : null}
            {numAccounts > 0 && (
                <NavLink
                    className={`${classes.pageLink} ${isActive(classes.active, ['/overview'], matchOverview)}`}
                    title={isExpanded ? '' : 'Overview'}
                    to="/overview"
                >
                    <div className={classes.iconWrapper}>
                        <Overview />
                    </div>
                    <span className={classes.pageLinkText}>Overview</span>
                </NavLink>
            )}
        </div>
    );

    const dashboard = () => (
        <NavLink
            className={`${classes.pageLink} ${classes.dashboard} ${dashboardClass()}`}
            title={isExpanded ? '' : 'Dashboard'}
            to="/dashboard"
        >
            <div className={classes.iconWrapper}>
                <Dashboard />
            </div>
            <span className={classes.pageLinkText}>Dashboard</span>
        </NavLink>
    );

    const approvals = (upgradePrompt) => (
        <>
            <NavLink
                className={`${classes.pageLink} ${isActive(approvalActiveClassName, ['/approvals'], matchApprovals)}`}
                title={isExpanded ? '' : 'Approvals'}
                to="/approvals/pending"
            >
                <div className={classes.iconWrapper}>
                    <Approvals />
                </div>
                <span className={classes.pageLinkText}>Approvals</span>

                {upgradePrompt ? (
                    <div className={classes.upgradeIndicator}>
                        <div />
                        <div />
                    </div>
                ) : (
                    <div className={classes.childrenIndicator}>
                        <div />
                        <div />
                    </div>
                )}
            </NavLink>
            {matchApprovals !== null && (
                <div className={classes.childPageSection}>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(
                            classes.active,
                            ['/approvals/policies'],
                            matchApprovals
                        )}`}
                        title={isExpanded ? '' : 'Policies'}
                        to="/approvals/policies/expenses"
                    >
                        <span className={classes.pageLinkText}>Policies</span>
                    </NavLink>
                </div>
            )}
        </>
    );
    const bills = (upgradePrompt) => (
        <Prism featureName="Bills" fallback={<></>}>
            <NavLink
                className={`${classes.pageLink} ${isActive(classes.active, ['/bills'], matchBills)}`}
                title={isExpanded ? '' : 'Bills'}
                to="/bills/drafts"
            >
                <div className={classes.iconWrapper}>
                    <Bills />
                </div>

                <span className={classes.pageLinkText}>Bills</span>
                {upgradePrompt ? (
                    <div className={classes.upgradeIndicator}>
                        <div />
                        <div />
                    </div>
                ) : null}
            </NavLink>
        </Prism>
    );

    const recipients = () => (
        <NavLink
            className={`${classes.pageLink} ${isActive(classes.active, ['/recipients'], matchBills)}`}
            title={isExpanded ? '' : 'Recipients'}
            to="/recipients"
        >
            <div className={classes.iconWrapper}>
                <Recipients />
            </div>

            <span className={classes.pageLinkText}>Recipients</span>
        </NavLink>
    );

    const payments = () => (
        <>
            <NavLink
                className={`${classes.pageLink} ${paymentsClass()}`}
                title={isExpanded ? '' : 'Payments'}
                to="/payments"
            >
                <div className={classes.iconWrapper}>
                    <Payments />
                </div>
                <span className={classes.pageLinkText}>Payments</span>
                <div className={classes.childrenIndicator}>
                    <div />
                    <div />
                </div>
            </NavLink>
            {paymentsClass() !== '' && (
                <div className={classes.childPageSection}>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(
                            classes.active,
                            ['/payments/batch'],
                            matchPayments
                        )}`}
                        title={isExpanded ? '' : 'Batch'}
                        to="/payments/batch"
                    >
                        <span className={classes.pageLinkText}>Batch</span>
                        {status !== 'APPROVED' && (
                            <div className={classes.lock}>
                                <Lock />
                            </div>
                        )}
                    </NavLink>
                    {isBusinessAccountPlan ? null : (
                        <>
                            <NavLink
                                className={`${classes.pageLink} ${isActive(
                                    classes.active,
                                    ['/payments/payroll'],
                                    matchPayments
                                )}`}
                                title={isExpanded ? '' : 'Payroll'}
                                to="/payments/payroll"
                            >
                                <span className={classes.pageLinkText}>Payroll</span>
                                {status !== 'APPROVED' && (
                                    <div className={classes.lock}>
                                        <Lock />
                                    </div>
                                )}
                            </NavLink>
                            <Prism
                                featureName="Bills"
                                fallback={
                                    <NavLink
                                        className={`${classes.pageLink} ${isActive(
                                            classes.active,
                                            ['/payments/partial'],
                                            matchPayments
                                        )}`}
                                        title={isExpanded ? '' : 'Partial'}
                                        to="/payments/partial"
                                    >
                                        <span className={classes.pageLinkText}>Partial</span>
                                        {status !== 'APPROVED' && (
                                            <div className={classes.lock}>
                                                <Lock />
                                            </div>
                                        )}
                                    </NavLink>
                                }
                            >
                                <></>
                            </Prism>
                        </>
                    )}
                </div>
            )}
        </>
    );

    const cards = () => (
        <>
            <NavLink
                className={`${classes.pageLink} ${parentSectionClass(`${cardsHomeUrl}/active`)}`}
                title={isExpanded ? '' : 'Cards'}
                to={`${cardsHomeUrl}/active`}
            >
                <div className={classes.iconWrapper}>
                    <Cards />
                </div>
                <span className={classes.pageLinkText}>Cards</span>
                <div className={classes.childrenIndicator}>
                    <div />
                    <div />
                </div>
            </NavLink>
            {matchCardsGPS !== null && (
                <div className={classes.childPageSection}>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(
                            classes.active,
                            [`${cardsHomeUrl}/user/${getCurrentUserId()}`],
                            matchCardsGPS
                        )}`}
                        title={isExpanded ? '' : 'Your cards'}
                        to={`${cardsHomeUrl}/user/${getCurrentUserId()}`}
                    >
                        <span className={classes.pageLinkText}>Your cards</span>
                    </NavLink>
                </div>
            )}
        </>
    );
    const expenses = (upgradePrompt) => (
        <NavLink
            className={`${classes.pageLink} ${isActive(classes.active, ['/expenses'], matchExpenses)}`}
            title={isExpanded ? '' : 'Expenses'}
            to={`/expenses/open`}
        >
            <div className={classes.iconWrapper}>
                <Expenses />
            </div>
            <span className={classes.pageLinkText}>Expenses</span>
            {upgradePrompt ? (
                <div className={classes.upgradeIndicator}>
                    <div />
                    <div />
                </div>
            ) : null}
        </NavLink>
    );
    const budgets = (upgradePrompt) => (
        <Prism featureName="Budgets" fallback={<></>}>
            <NavLink
                className={`${classes.pageLink} ${isActive(classes.active, ['/budgets'], matchBudgets)}`}
                title={isExpanded ? '' : 'Budgets'}
                to="/budgets/active"
            >
                <div className={classes.iconWrapper}>
                    <Budgets />
                </div>
                <span className={classes.pageLinkText}>Budgets</span>
                {upgradePrompt ? (
                    <div className={classes.upgradeIndicator}>
                        <div />
                        <div />
                    </div>
                ) : null}
            </NavLink>
        </Prism>
    );

    const accounts = () => (
        <>
            <NavLink
                className={`${classes.pageLink} ${parentSectionClass('/accounts')}`}
                title={isExpanded ? '' : 'Accounts'}
                to="/accounts"
            >
                <div className={classes.iconWrapper}>
                    <Accounts />
                </div>
                <span className={classes.pageLinkText}>Accounts</span>
                <div className={classes.childrenIndicator}>
                    <div />
                    <div />
                </div>
            </NavLink>

            {matchAccounts !== null && (
                <div className={classes.childPageSection}>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(
                            classes.active,
                            ['/accounts/convert'],
                            matchAccounts
                        )}`}
                        title={isExpanded ? '' : 'Convert'}
                        to={`/accounts/convert/${baseCurrency}/${buyCurrency}`}
                    >
                        <span className={classes.pageLinkText}>Convert</span>
                        {status !== 'APPROVED' && (
                            <div className={classes.lock}>
                                <Lock />
                            </div>
                        )}
                    </NavLink>
                </div>
            )}
        </>
    );
    const payroll = (upgradePrompt) => (
        <NavLink
            className={`${classes.pageLink} ${location.pathname === '/payments/payroll' ? classes.active : ''}`}
            title={isExpanded ? '' : 'Payroll'}
            to="/payments/payroll"
        >
            <div className={classes.iconWrapper}>
                <Payroll />
            </div>
            <span className={classes.pageLinkText}>Payroll</span>
            {upgradePrompt ? (
                <div className={classes.upgradeIndicator}>
                    <div />
                    <div />
                </div>
            ) : null}
        </NavLink>
    );
    const team = (upgradePrompt) => (
        <NavLink
            className={`${classes.pageLink} ${parentSectionClass('/team')}`}
            title={isExpanded ? '' : 'Team'}
            to="/team"
        >
            <div className={classes.iconWrapper}>
                <Team />
            </div>
            <span className={classes.pageLinkText}>Team</span>
            {upgradePrompt ? (
                <div className={classes.upgradeIndicator}>
                    <div />
                    <div />
                </div>
            ) : null}
        </NavLink>
    );

    const setup = () => (
        <>
            <NavLink
                className={`${classes.pageLink} ${isActive(parentSectionClass('/setup'), ['/setup'], matchSetup)}`}
                title={isExpanded ? '' : 'Setup'}
                to="/setup/account"
            >
                <div className={classes.iconWrapper}>
                    <Setup />
                </div>
                <span className={classes.pageLinkText}>Setup</span>
                <div className={classes.childrenIndicator}>
                    <div />
                    <div />
                </div>
            </NavLink>

            {matchSetup !== null && (
                <div className={classes.childPageSection}>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(classes.active, ['/setup/account'], matchSetup)}`}
                        title={isExpanded ? '' : 'Account setup'}
                        to="/setup/account"
                    >
                        <span className={classes.pageLinkText}>Account</span>
                    </NavLink>
                    <NavLink
                        className={`${classes.pageLink} ${isActive(classes.active, ['/setup/user'], matchSetup)}`}
                        title={isExpanded ? '' : 'User setup'}
                        to="/setup/user"
                    >
                        <span className={classes.pageLinkText}>User</span>
                    </NavLink>
                    <NavLink
                        className={`${classes.pageLink}  ${isActive(
                            classes.active,
                            ['/setup/integrations'],
                            matchSetup
                        )}`}
                        title={isExpanded ? '' : 'Integrations'}
                        to="/setup/integrations"
                    >
                        <span className={classes.pageLinkText}>Integrations</span>
                    </NavLink>

                    <NavLink
                        className={`${classes.pageLink} ${isActive(classes.active, ['/setup/billing'], matchSetup)}`}
                        title={isExpanded ? '' : 'Billing details'}
                        to="/setup/billing"
                    >
                        <span className={classes.pageLinkText}>Billing</span>
                    </NavLink>
                    {isFenix && (
                        <NavLink
                            className={`${classes.pageLink} ${isActive(
                                classes.active,
                                ['/setup/pricing'],
                                matchSetup
                            )}`}
                            title={isExpanded ? '' : 'Pricing'}
                            to="/setup/pricing"
                        >
                            <span className={classes.pageLinkText}>Pricing</span>
                        </NavLink>
                    )}
                </div>
            )}
        </>
    );

    const fenixItems = () =>
        isFenix && (
            <Home
                classNames={{ navLink: classes.pageLink, navIcon: classes.iconWrapper, navText: classes.pageLinkText }}
            />
        );

    const standardMenu = () => (
        <>
            {dashboard()}
            {approvals()}
            {bills()}
            {payments()}
            {recipients()}
            {cards()}
            {expenses()}
            {budgets()}
            {accounts()}
            {team()}
            {setup()}
        </>
    );
    const businessAccountMenu = () => (
        <>
            {dashboard()}
            {accounts()}
            {payments()}
            {recipients()}
            {cards()}
            {budgets()}
            {setup()}
        </>
    );

    return (
        <div className={wrapperStyles()}>
            <div>
                {logo()}
                <div>{fenixItems()}</div>
                <div className={`${classes.middleSection} ${isExpanded ? classes.middleSectionExpanded : ''}`}>
                    <nav>
                        {notifications?.subscription?.errors && !notifications.subscription.errors.valid ? (
                            renderInvalidSubscriptionLinks()
                        ) : (
                            <>
                                {accountSelection()}
                                <div className={`${classes.section} ${classes.second}`}>
                                    {isBusinessAccountPlan ? businessAccountMenu() : standardMenu()}
                                </div>
                                {isBusinessAccountPlan ? (
                                    <div className={`${classes.section} ${classes.paidFeatures}`}>
                                        <div>
                                            <span>PAID FEATURES</span>
                                            <div className={classes.badge}>
                                                <Badge
                                                    text="UPGRADE"
                                                    color="#457CED"
                                                    href="/setup/billing/change-plan"
                                                />
                                            </div>
                                        </div>
                                        {approvals('upgradePrompt')}
                                        {bills('upgradePrompt')}
                                        {expenses('upgradePrompt')}
                                        {payroll('upgradePrompt')}
                                        {team('upgradePrompt')}
                                    </div>
                                ) : null}
                            </>
                        )}
                        {notifications.actions.length > 0 && isExpanded && (
                            <div className={classes.notification}>
                                <NotificationAction notification={notifications.actions[0]} />
                            </div>
                        )}
                    </nav>
                </div>

                <div className={classes.bottomSection}>
                    <NavLink
                        className={`${classes.pageLink} ${classes.referrals} ${isActive(classes.active, ['/refer'])}`}
                        title={isExpanded ? '' : 'Invite a friend'}
                        to="/refer"
                    >
                        <div className={classes.iconWrapper}>
                            <Gift />
                        </div>
                        <span className={`${classes.pageLinkText} ${classes.referralLink}`}>
                            Refer and earn
                            {/* <span className={classes.referralAmount}>$100</span> */}
                        </span>
                    </NavLink>
                    <Prism
                        featureName="SalesforceLiveChat"
                        fallback={
                            <a
                                target="_blank"
                                className={`${classes.pageLink}`}
                                title={isExpanded ? '' : 'Help'}
                                href="https://knowledge.paytron.com/"
                            >
                                <div className={classes.iconWrapper}>
                                    <Help />
                                </div>
                                <span className={classes.pageLinkText}>Help</span>
                            </a>
                        }
                    >
                        <div
                            className={classes.pageLink}
                            ref={liveChatToggle}
                            onClick={() => setShowLiveChat(!showLiveChat)}
                        >
                            <div className={classes.iconWrapper}>
                                <Help />
                            </div>
                            <span className={classes.pageLinkText}>Help</span>
                        </div>
                    </Prism>

                    {showLiveChat
                        ? ReactDOM.createPortal(
                              <div ref={liveChat}>
                                  <LiveAgent />
                              </div>,
                              document.body
                          )
                        : null}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        page: state.page,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DesktopMenu);
